import { useState } from "react";
import { Download, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, clearSessions, download, errMsg } from "../lib/api";
import { BausteinManager, NotifySettings } from "../components/Notify";
import { GrundVorlagenManager } from "../components/GrundVorlagen";
import { Button, Card, ErrorBox, Field, Input } from "../components/kd";

function UebDatenschutz() {
  const [pw, setPw] = useState("");
  const [ok, setOk] = useState("");
  const [err, setErr] = useState("");
  const del = async () => {
    setErr("");
    try { await api.post("/konto/loeschen", { passwort: pw, bestaetigung: ok }); clearSessions(); toast.success("Ihr Konto wurde gelöscht."); window.location.assign("/"); }
    catch (e) { setErr(errMsg(e)); }
  };
  return (
    <Card className="border-danger" data-testid="ueb-datenschutz">
      <h2 className="mb-2">Meine Daten</h2>
      <p className="mb-3 text-sm text-text-muted">Laden Sie alle Daten Ihres Kontos herunter (Art. 15/20 DSGVO).</p>
      <Button variant="secondary" onClick={() => download("/konto/datenexport", "konsildent_datenexport.zip").catch((e) => toast.error(errMsg(e)))} data-testid="konto-export-button"><Download className="h-4 w-4" aria-hidden />Daten exportieren (ZIP)</Button>
      <h3 className="mb-2 mt-6">Konto löschen</h3>
      <p className="mb-3 text-sm text-text-muted">Löscht Ihr Konto, Ihre Benutzer- und Kontaktdaten (als Praxis-Administrator: das gesamte Praxiskonto mit allen Benutzern). Bereits überwiesene Fälle bleiben wegen der ärztlichen Aufbewahrungspflicht (10 Jahre) bei der Fachpraxis erhalten; Sie verlieren den Zugriff darauf.</p>
      <ErrorBox testid="konto-delete-error">{err}</ErrorBox>
      <div className="grid gap-3 sm:grid-cols-2">
        <Field label="Passwort" required htmlFor="dpw"><Input id="dpw" type="password" autoComplete="current-password" value={pw} onChange={(e) => setPw(e.target.value)} data-testid="konto-delete-password" /></Field>
        <Field label="Zur Bestätigung LÖSCHEN eingeben" required htmlFor="dok"><Input id="dok" value={ok} onChange={(e) => setOk(e.target.value)} placeholder="LÖSCHEN" data-testid="konto-delete-confirm" /></Field>
      </div>
      <Button variant="danger" disabled={ok !== "LÖSCHEN" || !pw} onClick={del} data-testid="konto-delete-button"><Trash2 className="h-4 w-4" aria-hidden />Konto endgültig löschen</Button>
    </Card>
  );
}

export default function Profil({ ueb }: { ueb?: boolean }) {
  return (
    <div className="kd-fade max-w-3xl space-y-5" data-testid="profil-page">
      <h1>Mein Bereich</h1>
      <NotifySettings />
      <BausteinManager />
      {ueb && <GrundVorlagenManager />}
      {ueb && <UebDatenschutz />}
    </div>
  );
}
